import type {
  CreditNoteCreateRequestType,
  CreditNoteCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCreditNoteCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CreditNoteCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `credit-note`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<CreditNoteCreateResponseType>(response).data,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.CreditNote],
      });
    },
  });
};
